import { render } from "./AddCourseModal.vue?vue&type=template&id=bed6ff20&scoped=true"
import script from "./AddCourseModal.vue?vue&type=script&lang=js"
export * from "./AddCourseModal.vue?vue&type=script&lang=js"

import "./AddCourseModal.vue?vue&type=style&index=0&id=bed6ff20&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bed6ff20"]])

export default __exports__